module.exports = __webpack_public_path__ + "img/fresh-veg.79e880fb.jpg";